import { render, staticRenderFns } from "./BookingHoliday.vue?vue&type=template&id=3886890a"
import script from "./BookingHoliday.vue?vue&type=script&lang=js"
export * from "./BookingHoliday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports